import { Card } from '@ui/components';
import { cn } from '@ui/lib/utils';

interface TableCardProps {
  children: React.ReactNode;
  className?: string;
}

export const TableCard = ({ children, className }: TableCardProps) => {
  return (
    <Card className={cn('flex flex-col overflow-hidden', className)}>
      {children}
    </Card>
  );
};
